import styled from "styled-components";

interface IContainerItem {
  showDivider?: boolean
  highlight?: boolean
}

export const ContainerItem = styled.div<IContainerItem>`
   border-left: ${({ showDivider, highlight }) => showDivider && !highlight ? '1px solid #E5E5E5' : 'none'};
   background: ${({ highlight }) => highlight ? 'linear-gradient(135deg, #C6016B 0%, #2D749C 100%)' : 'transparent'};
   border-radius: ${({ highlight }) => highlight ? '10px' : '0'};
   min-height: ${({ highlight }) => highlight ? '64px' : 'auto'};
   padding: 0px 24px;
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
   gap: 18px;
   text-align: left;

   h2 {
     display: block !important;
     flex: 0 0 48px;
     min-width: 48px;
     margin: 0;
     color: #2D749C;
     text-align: center;
   }

   p {
     margin: 0;
     max-width: 170px;
     color: ${({ highlight }) => highlight ? '#FFFFFF' : 'inherit'};
     line-height: 1.45;
     text-align: center;
   }
`
